<template>
    <div>
        <div class="main-content">
            <div class="account-user-sec">
                <div class="account-sec">
                    <div class="acount-sec">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6 col-centered">
                                    <div class="contact-sec">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="alert alert-danger alert-dismissible" role="alert" v-if="loginError">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    Giriş Bilgileri Hatalı!
                                                </div>
                                                <div class="widget-title">
                                                    <h3>Yurtlar Burada Yönetim Paneli Girişi</h3>
                                                    <span>Lütfen size verilen giriş bilgilerin doğruluğundan emin olun!</span>
                                                </div><!-- Widget title -->
                                                <div class="account-form">
                                                    <div class="row">
                                                        <div class="form-container col-md-12">
                                                            <input type="text" name="email" v-model="email" class="form-control form-input" required/>
                                                            <div class="form-placeholder">E-mail</div>
                                                        </div>
                                                        <div class=" form-container col-md-12">
                                                            <input type="password" name="password" v-model="password" class="form-control form-input" required/>
                                                            <div class="form-placeholder">Şifre</div>
                                                        </div>
                                                        <div class="feild col-md-12">
                                                            <input type="submit" value="Giriş Yap" class="btn btn-success pull-right mt10" style="margin-top:20px;" @click="login" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer>
                        <div class="container">
                            <p>© 2019 Yurtlar Burada <i class="fa fa-heart"></i></p>
                        </div>
                    </footer>
                </div><!-- Account Sec -->
            </div>
        </div><!-- Main Content -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                password: '',
                api: 'login',
                loginError: false,
            }
        },
        methods: {
            login() {
                this.$Progress.start()
                this.axios.post('login', {
                    username: this.email,
                    password: this.password
                }).then(response => {
                    if(response.data.status == 200) {
                        const token = response.data.token
                        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
                        localStorage.setItem('access_token', token)
                        this.$router.push('/');
                    }else {
                        this.loginError = true;
                    }
                }).catch(error => {
                  console.log(error);
                  this.loginError = true;
                })
            }
        },
    }
</script>

<style scoped>
.col-centered {
    float: none;
    margin: auto;
}
</style>
